import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from "@/modules/promocodes/routers"

export default {
  install: () => {
    RouteRegister.handle(routers)
  },
}
